import { Box, Typography } from "@mui/material";

interface InfoFieldProps {
  label: string;
  value?: string;
  destaque?: boolean;
}

export function InfoField({ label, value, destaque }: InfoFieldProps) {
  return (
    <Box>
      <Typography variant="caption" color="text.secondary" display="block">
        {label}
      </Typography>
      <Typography variant={destaque ? "body2" : "body1"} fontWeight={destaque ? 600 : undefined}>
        {value || "-"}
      </Typography>
    </Box>
  );
}
